import React from 'react';

import Contacts from './contacts';
import DealField from 'bundles/apex/deals/form/fields/field';

function DealOwners(props) {
  return <Contacts {...props} role="owner_landlord" />;
}

export default DealField(DealOwners, 'owner');
